import React from 'react';
import { SettingsLayout } from '../components/SettingsLayout';
import { GeneralSettingsForm } from '../components/GeneralSettingsForm';
import { useSelector } from 'react-redux';
import { useSelectWithParams } from '../../../../../utils/selector.utils';
import { authSelectors } from '../../../../../app/auth/auth.selectors';
import { settingsSelectors } from '../../../../../app/resource/settings/settings.selectors';
import { userSelectors } from '../../../../../app/resource/user/user.selectors';

export const GeneralSettingsPage = () => {
  const loggedUserId = useSelector(authSelectors.selectLoggedUser);
  const loggedUser = useSelectWithParams(userSelectors.selectResourceById, loggedUserId ? loggedUserId : '');
  const settings = useSelectWithParams(
    settingsSelectors.selectResourceById,
    loggedUser?.tenantId ? loggedUser.tenantId : '',
  );

  return (
    <SettingsLayout activeTab="generalSettings">{settings && <GeneralSettingsForm data={settings} />}</SettingsLayout>
  );
};
